@if (credentials && credentials.length > 0) {
  <div class="credential-group-container">
    <h2>In Progress Applications</h2>
    <div
      [ngClass]="{
        'credential-section-container': credentials.length > 1,
        'credential-section-single': credentials.length === 1
      }"
    >
      @for (credential of credentials; track credential) {
        <section class="page-section credential-section">
          <div class="mt-1 header-row">
            <div class="header-text">
              <h3 class="credential-name">{{ credential.credentialName }}</h3>
            </div>
            <div>
              <div class="rounded">
                <span>
                  <svg width="10" height="10" class="mr-1">
                    <circle
                      [ngClass]="getColor(credential)"
                      class="status-dot"
                      cx="5"
                      cy="5"
                      r="4"
                      stroke-width="0"
                    />
                  </svg>
                  {{ getLabel(credential) }}
                </span>
              </div>
            </div>
          </div>
          <table class="credential-info-table">
            <tr>
              <td><b>Start Date</b></td>
              <td>
                {{ credential.application.startDate | date: 'mediumDate' }}
              </td>
            </tr>
            @if (credential.application.deadline) {
              <tr>
                <td><b>Deadline</b></td>
                <td>
                  {{ credential.application.deadline | date: 'mediumDate' }}
                </td>
              </tr>
            }
          </table>
        </section>
      }
    </div>
  </div>
}
